const EditIcons = ({styled}) => {
	return (
		<svg
        className={styled ? styled : "icons-gray"}
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M14.5355 3.8076C15.7071 2.63603 17.6066 2.63603 18.7782 3.8076L20.1924 5.22182C21.364 6.39339 21.364 8.29289 20.1924 9.46446L9.79989 19.857C9.66029 19.9966 9.48249 20.0917 9.2889 20.1304L3.9856 21.1911C3.28588 21.331 2.66896 20.7141 2.8089 20.0144L3.86956 14.7111C3.90828 14.5175 4.00343 14.3397 4.14303 14.2001L14.5355 3.8076ZM17.364 5.22182L18.7782 6.63603C19.1687 7.02656 19.1687 7.65972 18.7782 8.05024L17.364 9.46446L14.5355 6.63603L15.9498 5.22182C16.3403 4.83129 16.9734 4.83129 17.364 5.22182ZM13.1213 8.05025L5.77134 15.4002L5.06424 18.9358L8.59977 18.2287L15.9498 10.8787L13.1213 8.05025Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default EditIcons;
